import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as dayjs from 'dayjs';

import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { SEARCH_WORD_SET } from '../../../../app/redux/actions/search';
import {
  APP_MENU_TOGGLE,
  APP_NAVIGATION_TOGGLE,
  MODAL_OPEN,
} from '../../../../app/redux/actions';

import {
  NavBarContainer,
  MainContentWrapper,
  ContentWrapper,
  SearchContainer,
  Notifications,
  ModalHeader,
  SeeAll,
  IconMenu,
  NameContainer,
  SearchWrapper,
  LogoWrapper,
  ActionWrapper,
  ModalContainer,
  LogoutWrapper,
  IconWrapperLogout,
  TutorWrapper,
  NameWrapper,
  TutorModal,
  TutorContainer,
} from './style';

import {
  CTA,
  CircleImage,
  Logo,
  NoResult,
  SearchBar,
  Text,
} from '../../../atoms';
import routes from '../../../../routes';
import compose from '../../../../utils/compose';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { NOTIFICATION_READ } from '../../../../app/redux/actions/notifications';
import {
  getLabelByType,
  getUrlFromNotification,
  replaceCourseSubstrings,
} from '../../../../utils/notifications';
import MenuIcon from '../../../atoms/MenuIcon';
import { MODULES } from '../../../../utils/modules';
import Icon from '../../../atoms/Icon';
import { OutsideAlerter } from '../../../../utils/useOutsideDetector';
import {
  NotificationContent,
  NotificationDescription,
  NotificationLabel,
  Status,
} from '../../../atoms/Modals/ModalNotifications/style';
import { ModalDownloadReportId } from '../../../atoms/Modals/ModalDownloadReport';
import { ToastInfo } from '../../Toast';

const NavBarDesktop = ({
  notificationMenuMobileOpen,
  setSearchWord,
  menuToggle,
  navigationMobileToogle,
  navigationMobile,
  mediaIsLaptop,
  notifications,
  readNotification,
  username,
  modules,
  isTutor,
  isCotutor,
  isSupervisor,
  isSubjectExpert,
  modalOpen,
}) => {
  const navigate = useNavigate();
  const { pathname: location } = useLocation();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [noNotification, setNoNotification] = useState(true);
  const [tutorOpen, setTutorOpen] = useState(false);

  useEffect(() => {
    setNotificationOpen(false);
    setTutorOpen(false);
  }, [location]);

  const [search, setSearch] = useState('');
  const handleOnChangeSearch = (value) => {
    setSearch(value);
  };

  const handleOnSubmitSearch = (e) => {
    e.preventDefault();
    if (search?.trim()?.length > 2) {
      setSearch('');
      setSearchWord(search);
      navigate(routes.search.path);
    } else {
      toast.info(
        <ToastInfo
          title="Attenzione"
          body="La ricerca deve contenere almeno 3 caratteri"
        />,
        {
          toastId: 'infoSearchText',
        }
      );
    }
  };

  const changeLocation = (url) => {
    menuToggle();
    navigate(url);
  };

  const toggleNotification = () => {
    setNotificationOpen(!notificationOpen);
    if (navigationMobile) navigationMobileToogle();
  };

  const toggleTutor = () => {
    setTutorOpen(!tutorOpen);
  };

  const handleOnClickSeeAll = () => {
    toggleNotification();
    navigate(routes.notifications.path);
  };

  const handleOnClickBookmarks = () => {
    setNotificationOpen(false);
    navigate(routes.bookmarks.path);
  };

  const handleOnClickNotifcation = (item) => {
    toggleNotification();
    if (item.status === 0) readNotification({ ids: [item.id], status: 1 });
    const url = getUrlFromNotification(item);
    navigate(url);
  };

  useEffect(() => {
    // 0 --> not_read, 1 --> read
    setNoNotification(notifications?.every((item) => item.status === 1));
  }, [notifications]);

  return (
    <NavBarContainer>
      <ContentWrapper>
        <ActionWrapper>
          <LogoWrapper>
            <Logo size={Logo.SIZE.SMALL} defaultLogo />
          </LogoWrapper>
          <SearchWrapper>
            <SearchContainer style={{ left: mediaIsLaptop ? '11.5rem' : '' }}>
              <SearchBar
                placeholder="Cosa vuoi cercare?..."
                mobile
                value={search}
                onChange={handleOnChangeSearch}
                onSubmit={handleOnSubmitSearch}
                onClickClose={() => setSearch('')}
              />
            </SearchContainer>
          </SearchWrapper>
          <MainContentWrapper>
            <MenuIcon
              onClick={handleOnClickBookmarks}
              isActive={location === routes.bookmarks.path}
              iconClass="star-01"
              label="bookmarksTitle"
            />
            {modules.includes(MODULES.NOTIFICATIONS) && (
              <div style={{ position: 'relative' }}>
                <MenuIcon
                  onClick={() => toggleNotification()}
                  isActive={location?.includes('/notific') || notificationOpen}
                  iconClass="bell-01"
                  notificationBadge={noNotification === false}
                  label="notificationsTitle"
                />
                {notificationOpen && (
                  <OutsideAlerter onClick={toggleNotification}>
                    <ModalContainer className="notifications">
                      <Notifications
                        className={`notification-menu-mobile ${
                          notificationMenuMobileOpen ? 'open' : ''
                        }`}
                      >
                        <ModalHeader>
                          <Text type="h1.5">Notifiche</Text>
                          <IconMenu onClick={toggleNotification}>
                            <span className="close" />
                          </IconMenu>
                        </ModalHeader>
                        {notifications?.length > 0 ? (
                          <NotificationContent>
                            {(notifications || [])
                              .slice(0, 5)
                              .map((itemNotification) => (
                                <NotificationDescription
                                  key={`notification--${itemNotification?.id}`}
                                  notRead={itemNotification.status === 0}
                                  onClick={() =>
                                    handleOnClickNotifcation(itemNotification)
                                  }
                                >
                                  <div className="info-wrapper">
                                    {itemNotification.status === 0 && (
                                      <Status />
                                    )}
                                    <Text type="h3" className="action">
                                      {getLabelByType(itemNotification)}:
                                    </Text>
                                    <Text type="b4" className="date" mb={0}>
                                      {dayjs(
                                        new Date(
                                          (itemNotification?.created || 0) *
                                            1000
                                        )
                                      ).format('DD/MM/YYYY')}
                                    </Text>
                                  </div>
                                  <NotificationLabel>
                                    <Text type="h3">
                                      {itemNotification?.title}
                                    </Text>
                                    <Text type="b4">
                                      {replaceCourseSubstrings({
                                        input: itemNotification?.body,
                                      })}
                                    </Text>
                                  </NotificationLabel>
                                </NotificationDescription>
                              ))}
                          </NotificationContent>
                        ) : (
                          <NoResult text="Non ci sono notifiche" />
                        )}
                        <SeeAll>
                          <CTA
                            btnText="Mostra tutto"
                            icon="arrow-narrow-right"
                            type="tertiary"
                            bottomRight
                            onClick={() => handleOnClickSeeAll()}
                          />
                        </SeeAll>
                      </Notifications>
                    </ModalContainer>
                  </OutsideAlerter>
                )}
              </div>
            )}
            <NameContainer>
              <NameWrapper onClick={() => navigate(routes.editProfile.path)}>
                <CircleImage
                  name={username}
                  src={username?.profile_pic}
                  size={35}
                />
                <Text type="h3">
                  {username?.first_name} {username?.last_name}
                </Text>
              </NameWrapper>
              {typeof isTutor === 'boolean' && (isTutor || isCotutor) && (
                <TutorContainer>
                  <TutorWrapper onClick={toggleTutor}>
                    <Text type="h3">
                      {isSupervisor
                        ? 'Attività Supervisor'
                        : isTutor
                        ? 'Attività Tutor'
                        : 'Attività Co-Tutor'}
                      <Icon
                        type="chevron-down"
                        size={24}
                        rotate={tutorOpen ? 180 : 0}
                      />
                    </Text>
                  </TutorWrapper>
                  {tutorOpen && (
                    <OutsideAlerter onClick={toggleTutor}>
                      <ModalContainer className="tutor">
                        <TutorModal as="nav">
                          {isTutor && (
                            <Text
                              type="h3"
                              onClick={() =>
                                navigate(routes.chooseCourseType.path)
                              }
                              tag="button"
                            >
                              Creazione percorso formativo
                            </Text>
                          )}

                          <div
                            className={isTutor ? 'link-cta' : 'link-cta border'}
                          >
                            <Text
                              type="h3"
                              onClick={() =>
                                navigate(routes.tutorCourseList.path)
                              }
                              tag="button"
                            >
                              Gestione percorso formativo
                            </Text>
                            {isTutor && (
                              <>
                                <Text
                                  type="b3"
                                  onClick={() =>
                                    navigate(routes.liveEventList.path)
                                  }
                                  tag="button"
                                >
                                  Gestione eventi dal vivo
                                  <Icon type="settings-04" />
                                </Text>
                                {isSupervisor && (
                                  <Text
                                    type="b3"
                                    onClick={() =>
                                      navigate(routes.approvalList.path)
                                    }
                                    tag="button"
                                  >
                                    Gestione richieste di approvazione
                                    <Icon type="edit-04" />
                                  </Text>
                                )}
                              </>
                            )}
                          </div>
                          {isTutor && (
                            <Text
                              type="h3"
                              onClick={() => navigate(routes.groupList.path)}
                              tag="button"
                            >
                              I miei gruppi
                            </Text>
                          )}
                          {isTutor && (
                            <div className="link-cta">
                              <Text
                                type="h3"
                                onClick={() => navigate(routes.statistics.path)}
                                tag="button"
                              >
                                Statistiche e reportistica
                              </Text>
                              <Text
                                type="b3"
                                onClick={() => modalOpen(ModalDownloadReportId)}
                                tag="button"
                              >
                                Download statistiche <Icon type="download-01" />
                              </Text>
                            </div>
                          )}
                          {isSupervisor && (
                            <Text
                              type="h3"
                              onClick={() => navigate(routes.logsList.path)}
                              tag="button"
                            >
                              Elenco log
                            </Text>
                          )}
                          {isSupervisor && (
                            <Text
                              type="h3"
                              onClick={() =>
                                navigate(routes.sendNewsletter.path)
                              }
                              tag="button"
                            >
                              Creazione newsletter
                            </Text>
                          )}
                          <Text
                            type="h3"
                            onClick={() => navigate(routes.scormList.path)}
                            tag="button"
                          >
                            Catalogo attività
                          </Text>
                          {(isSupervisor || isSubjectExpert) && (
                            <Text
                              type="h3"
                              onClick={() =>
                                navigate(routes.documentsExpert.path)
                              }
                              tag="button"
                            >
                              Scambio documentale
                            </Text>
                          )}
                        </TutorModal>
                      </ModalContainer>
                    </OutsideAlerter>
                  )}
                </TutorContainer>
              )}
              {typeof isSubjectExpert === 'boolean' &&
                !(isTutor || isCotutor) &&
                (isSupervisor || isSubjectExpert) && (
                  <TutorWrapper onClick={toggleTutor}>
                    <Text type="h3">
                      Attività Esperto
                      <Icon
                        type="chevron-down"
                        size={24}
                        rotate={tutorOpen ? 180 : 0}
                      />
                    </Text>
                    {tutorOpen && (
                      <OutsideAlerter onClick={toggleTutor}>
                        <ModalContainer className="tutor">
                          <TutorModal as="nav">
                            <Text
                              type="h3"
                              onClick={() =>
                                navigate(routes.documentsExpert.path)
                              }
                              tag="button"
                            >
                              Scambio documentale
                            </Text>
                          </TutorModal>
                        </ModalContainer>
                      </OutsideAlerter>
                    )}
                  </TutorWrapper>
                )}
            </NameContainer>
            <LogoutWrapper onClick={() => changeLocation(routes.public.path)}>
              <IconWrapperLogout>
                <Icon type="arrow-circle-broken-left" size={20} fill="none" />
              </IconWrapperLogout>
              <Text type="h3">Area pubblica</Text>
            </LogoutWrapper>
          </MainContentWrapper>
        </ActionWrapper>
      </ContentWrapper>
    </NavBarContainer>
  );
};

NavBarDesktop.propTypes = {
  // HOC withMediaQueries
  mediaIsLaptop: PropTypes.bool.isRequired,

  // HOC (connect, state)
  notificationMenuMobileOpen: PropTypes.bool.isRequired,
  navigationMobile: PropTypes.bool.isRequired,
  notifications: PropTypes.array,
  username: PropTypes.object,
  modules: PropTypes.array.isRequired,
  isTutor: PropTypes.bool,
  isCotutor: PropTypes.bool,
  isSupervisor: PropTypes.bool,
  isSubjectExpert: PropTypes.bool,

  // HOC (connect, dispatch)
  modalOpen: PropTypes.func.isRequired,
  setSearchWord: PropTypes.func,
  menuToggle: PropTypes.func.isRequired,
  navigationMobileToogle: PropTypes.func.isRequired,
  readNotification: PropTypes.func.isRequired,
};

const composed = compose(
  connect(
    (state) => ({
      notificationMenuMobileOpen: state.app.notificationMenuMobileOpen,
      notifications: state.notifications.headerNotification,
      navigationMobile: state.app.navigationMobile,
      username: state.user,
      modules: state.modules.modules,
      isTutor: state.user.isTutor,
      isCotutor: state.user.isCotutor,
      isSupervisor: state.user.isSupervisor,
      isSubjectExpert: state.user.isSubjectExpert,
    }),
    (dispatch) => ({
      modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
      setSearchWord: (payload) =>
        dispatch({ type: SEARCH_WORD_SET, response: payload }),
      menuToggle: () => dispatch({ type: APP_MENU_TOGGLE }),
      navigationMobileToogle: () => dispatch({ type: APP_NAVIGATION_TOGGLE }),
      readNotification: ({ ids, status }) =>
        dispatch({ type: NOTIFICATION_READ._REQUEST, ids, status }),
    })
  ),
  withMediaQueries
)(NavBarDesktop);
export default composed;
